import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useApolloClient } from '@apollo/client';
import { getCurrentGeoIPRegion } from '@atlassian/mpac-api-client';
import { hooks } from '@atlassian/mpac-utils';
var AppListingAppPricing = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "AppListingAppPricing" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "appId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hosting" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "AtlassianProductHostingType" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "billingCycle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "MarketplaceBillingCycle" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "countryCode" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketplacePricingPlan" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "appId" }, value: { kind: "Variable", name: { kind: "Name", value: "appId" } } }, { kind: "Argument", name: { kind: "Name", value: "hostingType" }, value: { kind: "Variable", name: { kind: "Name", value: "hosting" } } }, { kind: "Argument", name: { kind: "Name", value: "pricingPlanOptions" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "billingCycle" }, value: { kind: "Variable", name: { kind: "Name", value: "billingCycle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "countryCode" }, value: { kind: "Variable", name: { kind: "Name", value: "countryCode" } } }] } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "status" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "currency" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "tieredPricing" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "tierType" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "tiersMode" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "items" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PricingTierItem" }, directives: [] }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "PricingTierItem" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MarketplacePricingItem" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "floor" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "ceiling" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "amount" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "policy" }, arguments: [], directives: [] }] } }], loc: { start: 0, end: 539, source: { body: "query AppListingAppPricing(\n  $appId: ID!\n  $hosting: AtlassianProductHostingType!\n  $billingCycle: MarketplaceBillingCycle!\n  $countryCode: String\n) {\n  marketplacePricingPlan(\n    appId: $appId\n    hostingType: $hosting\n    pricingPlanOptions: { billingCycle: $billingCycle, countryCode: $countryCode }\n  ) {\n    status\n    currency\n    tieredPricing {\n      tierType\n      tiersMode\n      items {\n        ...PricingTierItem\n      }\n    }\n  }\n}\n\nfragment PricingTierItem on MarketplacePricingItem {\n  floor\n  ceiling\n  amount\n  policy\n}\n", name: "GraphQL request", locationOffset: { line: 1, column: 1 } } } };
export var DEFAULT_COUNTRY_CODE = 'US';
var usePromise = hooks.usePromise;
export var getCountryCode = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(mpacBaseUrl) {
    var _yield$getCurrentGeoI, countryCode;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getCurrentGeoIPRegion(mpacBaseUrl);

          case 3:
            _yield$getCurrentGeoI = _context.sent;
            countryCode = _yield$getCurrentGeoI.countryCode;
            return _context.abrupt("return", countryCode);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", DEFAULT_COUNTRY_CODE);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function getCountryCode(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getAppPricing = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client, mpacBaseUrl, variables) {
    var countryCode;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getCountryCode(mpacBaseUrl);

          case 2:
            countryCode = _context2.sent;
            return _context2.abrupt("return", client.query({
              query: AppListingAppPricing,
              variables: _objectSpread(_objectSpread({}, variables), {}, {
                countryCode: countryCode
              })
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getAppPricing(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
export var useAppPricingPlan = function useAppPricingPlan(_ref3) {
  var mpacBaseUrl = _ref3.mpacBaseUrl,
      hosting = _ref3.hosting,
      appId = _ref3.appId,
      billingCycle = _ref3.billingCycle;
  var client = useApolloClient();

  var _usePromise = usePromise(function () {
    return getAppPricing(client, mpacBaseUrl, {
      hosting: hosting,
      appId: appId,
      billingCycle: billingCycle
    });
  }, [mpacBaseUrl, hosting, appId, billingCycle]),
      result = _usePromise.result,
      loading = _usePromise.pending,
      error = _usePromise.error;

  return {
    loading: loading || (result === null || result === void 0 ? void 0 : result.loading),
    data: result === null || result === void 0 ? void 0 : result.data.marketplacePricingPlan,
    error: error || (result === null || result === void 0 ? void 0 : result.error)
  };
};